import { Box } from '@material-ui/core';
import { Billing } from '@nemuru-eng/js-api-client';

import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { AutocompleteNationalityFormField } from '@/components/shared/components/NewContextForms/AutocompleteNationalityFormField/AutocompleteNationalityFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';

interface BillingFormProps extends FormGridOptions {
  billing: Billing;
}

export const BillingForm = ({ billing, fieldVariant, fullWidth }: BillingFormProps) => {
  return (
    <Box pt={2}>
      <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth}>
        <TextFormField label={'FIRST_NAME'} name={'firstName'} value={billing.customer.name.first} />
        <TextFormField label={'LAST_NAME'} name={'lastName'} value={billing.customer.name.last} />
        <TextFormField label={'COMPANY_NAME'} name={'companyName'} value={billing.businessName} />
        <TextFormField label={'COMPANY_VAT'} name={'corporateIdNumber'} value={billing.corporateIdNumber} />
        <TextFormField label={'EMAIL'} name={'email'} value={billing.customer.email} />
        <TextFormField label={'PHONE_NUMBER'} name={'phone'} value={billing.customer.phone} />
        <TextFormField label={'STREET_ADDRESS'} name={'streetAddress'} value={billing.address.streetAddress} />
        <TextFormField label={'STREET_ADDRESS_2'} name={'streetAddress'} value={billing.address.streetAddress2} />
        <TextFormField label={'POSTAL_CODE'} name={'postalCode'} value={billing.address.postalCode} />
        <TextFormField label={'CITY'} name={'city'} value={billing.address.city} />
        <AutocompleteNationalityFormField name={'country'} label={'COUNTRY'} value={billing.address.country} />
      </FormGridContainer>
    </Box>
  );
};
